export function selectOnChangeSubmit(selectEl, hiddenEl, submitEl) {
  $(selectEl).on('change', (e) => {
    $(hiddenEl).val($(e.currentTarget).val());
    $(submitEl).submit()
  });
}
